import React, { useState, useEffect } from "react";
import img from "./Img/goneo.webp";

function BgGo() {
  const [isLargeScreen, setIsLargeScreen] = useState(
    () => window.matchMedia("(min-width: 1280px)").matches,
  );
  useEffect(() => {
    const mediaQuery = window.matchMedia("(min-width: 1280px)");
    const handleChange = (e) => setIsLargeScreen(e.matches);
    mediaQuery.addEventListener("change", handleChange);

    return () => {
      mediaQuery.removeEventListener("change", handleChange);
    };
  }, []);
  return (
    <>
      {isLargeScreen && (
        <div
          className="d-flex position-relative d-flex flex-column m-0 p-0 uh-122 justify-content-end"
          style={{
            overflow: "hidden",
          }}
        >
          {/* Image */}
          <div
            className="uh-122 m-0 p-0 w-100"
            style={{
              backgroundImage: `url(${img})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
              height: "85vh",
            }}
          ></div>
          <div
            className=" position-absolute upx-20 uh-110 upy-27 uw-130  " // Positioned to the top-right corner of the parent div
          >
            {/* Content inside the right-side div */}
            <p className=" m-0 p-0 ufs-13 fw-bold text-black">GoNeo</p>
            <p className=" m-0 p-0 ufs-4 fw-bold  text-black">
              Digital Goniometer For Pro Physios
            </p>

            {/* <div className="m-0 d-flex upy-5 text-center uh-50">
              <button
                className="ufs-6 uw-60 uh-12 text-center text-gray-light border-0 fw-bold bg-dark-blue br-10"
                type="button"
              >
                Buy Now
              </button>
            </div> */}
          </div>
        </div>
      )}
      {!isLargeScreen && (
        <div
          className="d-flex position-relative d-flex flex-column m-0 p-0 vh-100 w-100 justify-content-end"
          style={{
            overflow: "hidden",
          }}
        >
          {/* Image */}
          <div
            className="vh-100 m-0 p-0 w-100"
            style={{
              backgroundImage: `url(${img})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
              height: "85vh",
            }}
          ></div>
          <div
            className="  position-absolute upx-20 uh-200 upy-10 w-100 bottom-0   " // Positioned to the top-right corner of the parent div
          >
            {/* Content inside the right-side div */}
            <p className=" m-0 p-0 ufs-14 fw-bold text-gray">GoNeo</p>
            <p className=" m-0 p-0 ufs-12 fw-bold  text-gray">
              Digital Goniometer For Pro Physios
            </p>

            {/* <div className="m-0 d-flex upt-2 text-center uh-50">
              <button
                className="ufs-14 up-5 upx-10 text-center text-gray-light border-0 fw-bold bg-dark-blue br-20"
                type="button"
              >
                Buy Now
              </button>
            </div> */}
          </div>
        </div>
      )}
    </>
  );
}
export default BgGo;
